
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/listings",
      function () {
        return require("private-next-pages/admin/listings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/listings"])
      });
    }
  